import React from 'react'
import PropTypes from 'prop-types'
import ColumnFilter from './ColumnFilter'

const TableFilter = ({ filter, columnList, filterSetting, changeFilter, hiddenColumns }) => {
    return (
        <tr className="table-filter-row">
            {columnList
                .filter(column => !hiddenColumns.includes(column.property))
                .map(({ property, columnName }) => {
                return (
                    <th key={property}>
                        <ColumnFilter
                            changeFilter={changeFilter}
                            filter={filter}
                            property={property}
                            columnName={columnName}
                            filterSetting={filterSetting ? filterSetting[property] : null}
                        />
                    </th>
                )
            })}
        </tr>
    )
}

TableFilter.propTypes = {
    columnList: PropTypes.array.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    filterSetting: PropTypes.object,
}

export default TableFilter




// WEBPACK FOOTER //
// ./src/modules/table/component/TableFilter.js